export const teams = () => {
    const $ = jQuery;

    const teams_wrappers = $('.team .team-members-wrapper');

    if (teams_wrappers.length === 0) {
        return true;
    }

    $.each(teams_wrappers, (i, wrapper) => {
        const member_triggers = $(wrapper).find('.member-image-wrapper');

        const handleTriggerClick = (e) => {
            const trigger = $(e.currentTarget);

            if ($(trigger).hasClass('inactive') || !$(trigger).hasClass('has-bio')) {
                return false;
            }
            
            if ($(trigger).hasClass('active')) {
                member_triggers.removeClass('inactive');
                $(trigger).removeClass('active').next().slideUp();
            } else {
                member_triggers.not(trigger).addClass('inactive');
                $(trigger).addClass('active').next().slideDown();
            }
        }

        $(member_triggers).on('click', handleTriggerClick);
    });
};